import { injectable } from 'inversify';
import container from '@core/di';
import BaseStore from '@core/stores/base';
import { makeObservable, observable, action, runInAction } from 'mobx';
import { SubscriptionPlan } from '@shared/models/subscriptionplan';
import SubscriptionsService from '@shared/services/subscriptions';

@injectable()
export default class SubscriptionsStore extends BaseStore<SubscriptionPlan, SubscriptionsService> {
  static diToken = Symbol('subscriptions-store');

  private _subscriptions: SubscriptionPlan[] = [];
  private _isFetched = false;

  constructor() {
    super({ service: container.get<SubscriptionsService>(SubscriptionsService.diToken) });
    makeObservable<any>(this, {
      _subscriptions: observable,
      _isFetched: observable,
      current: action,
      subscriptions: action,
    });

    this.loading = {
      list: false,
      item: false,
    };
  }

  current = async () => {
    const subscriptions = await this.getSubscriptions();

    runInAction(() => {
      this._subscriptions = subscriptions;
      this._isFetched = true;
    });

    return subscriptions;
  };

  get subscriptions(): SubscriptionPlan[] {
    return this._subscriptions;
  }

  set subscriptions(items: SubscriptionPlan[]) {
    this._subscriptions = items;
  }

  get isFetched(): boolean {
    return this._isFetched;
  }

  getSubscriptions = async () => {
    return await this.service.getSubscriptions();
  };

  update = async (subscriptionID: number, subscription) => {
    return await this.service.update(subscriptionID, subscription);
  };
}
